import i18n from '@/i18n'
import { sectorService } from '@/services/sector.service'
import { mapActions, mapGetters } from 'vuex'
import { EventHub } from '@/constants/constants'
import { DialogSector } from "@/tools/dialog"

export default {
    name: 'SectorDialogComponent',
    components: {
    },
    props: {
        // v-model injects the object to be edited into props.value
        model: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        // model del formulario
        validForm: false,
        // reglas de validación
        validationRules: {
            required: (value) => !!value || `${i18n.t('required')}`,
        },
        // errores para el campo del núm de línea
        nameError: [],
        // nombre actual
        actualName: null,
    }),
    computed: {
        ...mapGetters({
            'getBread': 'breadcrumbs/getBread',
        }),
    },
    created() {
        /**
         * El modelo de datos del diálogo se carga a través del objeto del breadcrumb
         */
        this.unwatch = this.$store.watch(
            (state, getters) => getters['breadcrumbs/getBread'],
                (newBreads) => {
                    const lastBreadcrumb = this.getBread[newBreads.length - 1]
                    if (!lastBreadcrumb) {
                        this.cancel()
                    } else {
                        if (lastBreadcrumb.key === DialogSector) {
                            if (lastBreadcrumb.model) {
                                const modelData = this.model
                                Object.assign(modelData, lastBreadcrumb.model)
                            }
                        }
                    }
                },
            { deep: true })
    },
    async mounted() {
        /**
         * El modelo de datos del diálogo se carga a través del objeto del breadcrumb
         */
        const lastBreadcrumb = this.getBread[this.getBread.length - 1]
        if (!lastBreadcrumb) {
            this.cancel()
        } else {
            if (lastBreadcrumb.key === DialogSector) {
                if (lastBreadcrumb.model) {
                    const modelData = this.model
                    Object.assign(modelData, lastBreadcrumb.model)
                }
            }
        }
    },
    beforeDestroy () {
        // elimino la instancia del watcher del breadcrumb
        this.unwatch()
    },
    methods: {
        /**
         * actions del snackbar
         */
        ...mapActions('snackbar', [
            'showSnackbar',
            'closeSnackbar'
        ]),
        /**
         * actions del dialog
         */
        ...mapActions('dialog', [
            'openDialog',
            'closeDialog'
        ]),
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pullBread',
            'pushBread'
        ]),
        /**
         * Mensaje de error cuando el nombre está duplicado
         */
        nameDuplicatedMethod() {
            if (!sectorService.validateSectorName(this.model.name, this.model.sectors)) {
                this.nameError.push(`${i18n.t('sector.duplicate')}`)
            } else {
                this.nameError = []
            }
        },
        /**
         * Resetea los campos del formulario de creación/actualización
         */
        resetFields() {
            if (this.$refs.form) {
                this.$refs.form.reset()
            }
        },
        /**
         * Click fuera del dialog
         */
        clickOutside() {
            this.cancel()
        },
        /**
         * Cancelar
         */
        cancel() {
            this.pullBread(DialogSector)
            this.resetFields()
        },
        /**
         * Guardar
         */
        save() {
            const sectorDto = this.getSectorDto()
            if (this.model.update) {
                // TODO: actualizar sector
            } else {
                this.$eventBus.$emit(EventHub.COMMIT_SECTOR, sectorDto)
            }
            this.cancel()
        },
        /**
         * Genera el DTO para actualizar / crear una finca
         * @param {*} update
         */
        getSectorDto() {
            const result = {
                name: this.model.name,
            }
            return result
        },
    },
    watch: {
        model: {
            deep: true,
            immediate: true,
            handler(newModel) {
                if (newModel) {
                    if (newModel.name) {
                        this.actualName = newModel.name
                    }
                }
            }
        },
    }
}
